import React from "react";
import { useNavigate } from "react-router-dom";

const NaboraUpdates = ({ data }) => {
  const navigate = useNavigate();

  const defaultData = {
    title: "Latest Nabora Updates",
    subtitle:
      "Stay connected with exhibitions, local commerce opportunities and community activities.",

    updates: [
      {
        icon: "🎪",
        title: "July Exhibition Registration Open",
        desc: "Merchants can now participate in the upcoming neighbourhood exhibition.",
        action: "/nabora/exhibitions",
        type: "exhibition",
      },
      {
        icon: "🏪",
        title: "New Merchant Onboarding Started",
        desc: "Local businesses can join Nabora and showcase their products digitally.",
        action: "/nabora/merchant",
        type: "merchant",
      },
      {
        icon: "🚀",
        title: "New Organiser Opportunities",
        desc: "Young entrepreneurs can build neighbourhood commerce networks.",
        action: "/nabora/organiser",
        type: "organiser",
      },
    ],
  };

  const content = data || defaultData;

  const handleUpdateAction = (item) => {
    switch (item.type) {
      case "exhibition":
        navigate("/nabora/exhibitions");
        break;

      case "merchant":
        navigate("/nabora/merchant");
        break;

      case "organiser":
        navigate("/nabora/organiser");
        break;

      default:
        if (item.action) {
          navigate(item.action);
        }
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="py-8 px-6 bg-gradient-to-br from-violet-950 via-purple-950 to-slate-950">
        <div className="max-w-5xl mx-auto text-center">
          <div className="uppercase tracking-[4px] text-yellow-300 text-sm mb-4">
            📢 NABORA UPDATES
          </div>

          <h1 className="text-2xl lg:text-4xl font-bold mb-4">
            {content.title}
          </h1>

          <p className="text-slate-300 text-base lg:text-xl max-w-3xl mx-auto">
            {content.subtitle}
          </p>
        </div>
      </div>

      <div className="py-8 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="space-y-5">
            {content.updates.map((item, index) => (
              <div
                key={index}
                className="bg-slate-900/80 rounded-3xl p-6 border border-white/10 hover:border-purple-400/50 transition-all flex flex-col md:flex-row md:items-center md:justify-between gap-4"
              >
                <div className="flex items-start gap-4">
                  <div className="text-4xl">{item.icon}</div>

                  <div>
                    <h2 className="text-cyan-200 text-lg lg:text-xl font-bold mb-2">
                      {item.title}
                    </h2>

                    <p className="text-slate-300 text-sm lg:text-base">
                      {item.desc}
                    </p>
                  </div>
                </div>

                <button
                  onClick={() => handleUpdateAction(item)}
                  className="px-5 py-2 rounded-xl bg-gradient-to-r from-fuchsia-500 to-violet-600 font-semibold hover:scale-105 transition-all whitespace-nowrap"
                >
                  View →
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-8 px-6 bg-gradient-to-br from-slate-900 to-violet-950">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-5xl mb-4">💜</div>

          <h2 className="text-cyan-200 text-xl lg:text-3xl font-bold mb-3">
            Stay Connected With Your Local Economy
          </h2>

          <p className="text-slate-300 mb-6">
            Nabora updates keep merchants, organisers and customers connected.
          </p>

          <button
            onClick={() => navigate("/nabora")}
            className="px-6 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
          >
            🏠 Back To Nabora
          </button>
        </div>
      </div>
    </div>
  );
};

export default NaboraUpdates;
